<template>
  <modal name="playVideo" classes="am-vue-modal" width="1200px" height="675px" :adaptive="true">
    <iframe v-bind:src="getSource()" class="video" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
  </modal>
</template>

<script>

export default {
  name: 'playVideo',

  props: {
    videoCode: {
      type: [String],
      required: true
    },
    videoType: {
      type: [String],
      required: true
    }
  },

  methods: {
    getSource () {
      if (this.videoType === 'vimeo') {
        return 'https://player.vimeo.com/video/' + this.videoCode + '?autoplay=1'
      } else {
        return 'https://www.youtube.com/embed/' + this.videoCode + +'?autoplay=1'
      }
    }
  }
}
</script>

<style scoped>

  .v--modal-overlay {
    background-color: rgba(0,0,0,0.7);
  }

  .video {
    width: 100%;
    height: 100%;
  }

</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
